/// <reference path="../_references.ts"/>

module App.Administrative.VendorInventory {
    export interface Tag {
        id: number;
        name: string;
        display_id: number;
    }
    export interface TagGroup {
        id: number;
        name: string;
        display_id: number;
        tags: Tag[];
    }
    export interface SerializedItem {
        id: number;
        serial: string|null;
        description: string|null;
    }
    export interface WarehouseCountMap {
        [id: number]: WarehouseCount;
    }
    export interface WarehouseCount {
        id: number;
        count: number;
        serialized_items: SerializedItem[];
        warehouse: {
            id: number;
            name: string;
        };
    }
    export interface VendorInventory {
        id: number;
        name: string;
        description: string|null;
        serialized: boolean;
        expanded?: boolean;
        updating?: boolean;
        favourite: boolean;
        warehouse_counts: WarehouseCountMap;
    }
    export interface VendorInventoryReplenishment {
        id: number;
    }
}
